import {LengthConverter} from "../converters/LengthConverter";

export class Cake {
    private lengthConverter = new LengthConverter()
    private readonly diameter: Diameter
    public readonly height: Height
    constructor(private readonly recipe: Recipe) {
        this.diameter = recipe.diameter
        this.height = recipe.height
    }

    public hasHeight() {return this.height.value > 0}
    public hasDiameter() {return this.diameter.value > 0}

    public calcArea(unit: LengthUnit) {
        const normalizedDiameter = this.lengthConverter.convert(this.diameter.value, this.diameter.unit, unit)
        return Math.pow((normalizedDiameter / 2), 2) * Math.PI
    }

    public calcVolume(unit: LengthUnit) {
        const area = this.calcArea(unit)
        const normalizedHeight = this.lengthConverter.convert(this.height.value, this.height.unit, unit)
        return area * normalizedHeight
    }

    public calcRelation(targetCake: Cake) {
        if (this.hasHeight() && targetCake.hasHeight() && this.hasDiameter() && targetCake.hasDiameter())
            return this.calcVolume("mm") / targetCake.calcVolume("mm")
        if (this.hasDiameter() && targetCake.hasDiameter())
            return this.calcArea("mm") / targetCake.calcArea("mm")
        if (this.hasHeight() && targetCake.hasHeight())
            this.calcHeightRelation(targetCake)
        return 1
    }

    public calcRecipeAdaption(targetCake: Cake) : Recipe {
        const relation = this.calcRelation(targetCake)
        const newRecipe : Recipe = JSON.parse(JSON.stringify(targetCake.recipe))
        const newIngredients = newRecipe.ingredients.map((ingredient: RecipeIngredient) => {
            ingredient.mass.value = ingredient.mass.value / relation
            return ingredient
        })
        newRecipe.mass.value = targetCake.recipe.mass.value / relation
        return {...newRecipe, ingredients: newIngredients}
    }

    private calcHeightRelation(cake: Cake) {
        const ownNormalizedHeight = this.lengthConverter.convert(this.height.value, this.height.unit, "mm")
        const otherNormalizedHeight = this.lengthConverter.convert(cake.height.value, cake.height.unit, "mm")
        return ownNormalizedHeight / otherNormalizedHeight
    }
}
